<template>
  <div class="container-tracker uk-background-muted">
    <containerTableView></containerTableView>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import containerTableView from './ContainerTracker/ContainerTableView.vue';

export default defineComponent({
  name: 'ContainerTracker',
  props: {
    msg: String,
  },
  components: {
    containerTableView,
  },
  beforeRouteEnter(to, from, next) {
    console.log('route enter happened', to, from);
    next();
  },
  beforeRouteUpdate(to: any, from: any, next) {
    console.log('route update happened', to, from);
    next();
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
